<template>
  <a
    class="favoriteCardMainWrapper"
    :href="`https://open.spotify.com/artist/${value.id}/`"
    target="_blank"
  >
    <img class="image" :src="artistImage" alt="" />
    <VText class="hover:tw-underline" cfg="sans/16/medium">{{
      value.name
    }}</VText>
  </a>
</template>

<script setup lang="ts">
import VText from '~/components/ui/VText.vue'

import type SpotifyArtist from '~/types/spotifyArtist'

type Props = {
  value: SpotifyArtist
}

const props = defineProps<Props>()

const artistImage = props.value.image
</script>

<style scoped lang="scss">
.favoriteCardMainWrapper {
  @apply tw-relative tw-flex tw-w-full tw-items-center;
}

.image {
  @apply tw-mr-4 tw-h-10 tw-w-10 tw-rounded-full tw-shadow-round;
}
</style>
